import React from "react";
import BenefitsWrapper from "ComponentsUI/Benefit/Components/BenefitsWrapper";
import images from "Configs/images.config";
import { replaceStaticHost } from "Helpers/ImageManager";

export default class BenefitsContainer extends React.Component {
	render() {
		let imageBenefit = {
			lg: replaceStaticHost(images.benefitLg),
			md: replaceStaticHost(images.benefitLg),
			sm: replaceStaticHost(images.benefitLg),
			xs: replaceStaticHost(images.benefitXs),
		};
		return <BenefitsWrapper datatest="main_benefits" imageBenefit={imageBenefit} />;
	}
}
